import { resetState } from '../context/appActions';
import { useAppDispatch } from '../context/appContext';
import { logoutUser } from '../context/kennoTenantActions';
import { useKennoTenantDispatch } from '../context/kennoTenantContext';

export const useLogout = () => {
  const kennoDispatch = useKennoTenantDispatch();
  const appDispatch = useAppDispatch();

  function logout() {
    logoutUser(kennoDispatch);
    resetState(appDispatch);
  }

  return { logout };
};
